import { IconPropsType } from '..';

export const ProfileIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.1403 12.1608C16.5289 14.1713 14.9745 15.6316 12.803 15.9607C10.7058 16.2795 7.28849 16.2795 5.19696 15.9607C3.02544 15.6316 1.47109 14.1713 1.85967 12.1608H1.86539C2.19683 10.4537 3.80262 9.38931 5.76842 9.48186C7.20277 9.54871 8.08281 9.71839 9.10571 9.71839C10.1286 9.71839 10.8258 9.54871 12.2487 9.48186C14.2088 9.38931 15.8203 10.4537 16.1517 12.1608H16.1403ZM8.73426 1.7998C10.7972 1.7998 12.4659 3.30639 12.4659 5.15749C12.4659 7.00859 10.7972 8.51518 8.73426 8.51518C6.67132 8.51518 5.00267 7.00859 5.00267 5.15749C5.00267 3.30639 6.67132 1.7998 8.73426 1.7998Z"
      fill="#23252A"
    />
  </svg>
);
